export const allowedFileExtensions = ["jpg", "png"]
